import { Button } from '@packages/shared/src/ui/Button/Button';
import {
  LoyaltyAccountDataType,
  LoyaltyEntitlementStatus,
  useLoyaltyApi,
} from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';
import useSWRMutation from 'swr/mutation';
import { useContext } from 'react';
import { useSWRConfig } from 'swr';
import { buttonMessages } from '../Payback/messages';
import { useLoyaltyEntitlementInformation } from './useLoyaltyEntitlementInformation';
import { usePaybackClient } from '../Payback/usePaybackClient';
import { PaybackFetchMethodContext } from '../Payback/PaybackAccountDataFetchProvider';

const statusButtonMap: Record<LoyaltyEntitlementStatus, MessageDescriptor> = {
  [LoyaltyEntitlementStatus.Rejected]: buttonMessages.DialogDeclineButton,
  [LoyaltyEntitlementStatus.Accepted]: buttonMessages.DialogAcceptButton,
  [LoyaltyEntitlementStatus.NewVersion]: buttonMessages.DialogUpdateButton,
};

export const UpdateLoyaltyEntitlementConsentButton = ({
  status,
}: {
  status: LoyaltyEntitlementStatus;
}) => {
  const { formatMessage, locale } = useIntl();
  const { mutate } = useSWRConfig();
  const { closeDialogHandler } = usePaybackClient();
  const { setFetchMethod } = useContext(PaybackFetchMethodContext);
  const { shortName } = useLoyaltyEntitlementInformation();
  const loyaltyApi = useLoyaltyApi();
  const { trigger } = useSWRMutation(
    'updateLoyaltyEntitlementConsent',
    () =>
      loyaltyApi?.updateLoyaltyEntitlementConsent({
        ecLocale: locale,
        loyaltyEntitlementItem: { shortName, status },
      }),
    // important to force a revalidation
    {
      onSuccess: () => {
        setFetchMethod(LoyaltyAccountDataType.AllUpdated);
        mutate('getLoyaltyAccountData');
        closeDialogHandler();
      },
    },
  );
  const handleUpdateLoyaltyEntitlementConsent = async () => {
    await trigger();
  };

  return (
    <Button onClick={handleUpdateLoyaltyEntitlementConsent} color="primary">
      {formatMessage(statusButtonMap[status])}
    </Button>
  );
};
